import { Component, Input, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-operator-identification',
  templateUrl: './operator-identification.component.html',
  styleUrls: ['./operator-identification.component.scss'],
})

export class OperatorIdentificationComponent  implements OnInit {

  /**
   * Variables
   */
  OperatorForm: FormGroup;

  /**
   * Input parameters
   */
  @Input() isSubOperator: boolean = false;

  constructor(private rootFormGroup: FormGroupDirective) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the vehicle form.
   */
  ngOnInit() {
    this.OperatorForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}
